// Widget Scripts
import countdownWidget from "./js/widgets/countdownWidget.js";
import cardWidget from "./js/widgets/cardWidget.js";

// Custom Theme Scripts
import "./js/localjs.js";

// Initialize Homepage Widgets if is required
$(document).ready(function () {
  countdownWidget();
  cardWidget();
});
